export const fixNewlines = (text: string) => {
  return text.replaceAll("\\n", "\n");
};
